import { useEffect, useState } from "react";
import { doc, setDoc } from "firebase/firestore";
import { getToken } from "firebase/messaging";
import { db, messaging, VAPID_KEY } from "../firebase";

export function useNotifications(userEmail: string | null) {
  const [permission, setPermission] = useState<NotificationPermission | null>(null);

  useEffect(() => {
    if (typeof window !== "undefined" && "Notification" in window) {
      setPermission(Notification.permission);
    }
  }, []);

  const requestPermission = async () => {
    if (!messaging || !userEmail) return;

    try {
      const perm = await Notification.requestPermission();
      setPermission(perm);

      if (perm === "granted") {
        const token = await getToken(messaging, { vapidKey: VAPID_KEY });
        console.log("Token obtenido:", token);
        if (token) {
          await setDoc(doc(db, "fcm_tokens", userEmail), {
            token,
            email: userEmail,
            updatedAt: new Date().toISOString()
          });
          console.log("Token FCM guardado en Firestore");
        } else {
          console.log("Token vacío — no se guardó");
        }
      }
    } catch (error) {
      console.error("Error completo:", JSON.stringify(error));
    }
  };

  return { permission, requestPermission };
}